import { defineStore } from "pinia";
import { computed } from "vue";
import { makeLogger } from "@/shared/consola";
import { useOnboarding } from "@/shared/projects/onboarding/useOnboarding";
import { t } from "@/i18n";
import { useActions, useMutations, useState } from "@/store/vuex-composition-mappers";
import SvgTickerLayout from "@/apps/ticker/project/onboarding/svg-previews/SvgTickerLayout.vue";
import { mapThemeToTickerColors } from "@/shared/projects/prepare-theme";

const STORE_NAME = "ticker-creator";
const logger = makeLogger("🍍" + STORE_NAME);

export const useTickerCreatorStore = defineStore(STORE_NAME, () => {
    logger.trace("👋hello");

    const { ticker } = useState("ticker", ["ticker"]);
    const { saveSnapshot } = useActions("ticker", ["saveSnapshot"]);
    const { showAlert } = useMutations(["showAlert"]);

    const {
        isCreatorShown,
        onboardState,
        previewCssVars,
        autoOpenCreator,
        toggleCreatorShown,
        updateProductInfo,
        validate,
    } = useOnboarding({
        initialValues: {
            hidePrompt: true,
            showProductPickerOnly: true,
        },
    });

    const templates = computed(() => []);

    const layouts = computed(() => []);

    const previewComponent = computed(() => SvgTickerLayout);

    return {
        onboardState,
        isCreatorShown,
        templates,
        layouts,
        previewCssVars,
        previewComponent,
        links: computed(() => ({
            video: "",
            docs: "",
        })),
        autoOpenCreator,
        onboardingAction() {
            return async () => {
                if (!validate()) {
                    return;
                }
                try {
                    onboardState.isLoading = true;
                    const { theme, productSelectLater, productDetails } = onboardState;
                    for (const [key, value] of Object.entries(mapThemeToTickerColors(theme))) {
                        ticker.value[key] = value;
                    }
                    const { id } = productSelectLater ? {} : productDetails;
                    if (id) {
                        logger.debug("Connect Ticker with product", productDetails);
                        ticker.value.ecProductIds = [{ id }];
                    }
                    showAlert({
                        type: "success",
                        title: t("shared.creator.generation_success"),
                    });
                    await saveSnapshot();
                    toggleCreatorShown(false);
                } catch (e) {
                    logger.error(e);
                } finally {
                    onboardState.isLoading = false;
                }
            };
        },
        toggleCreatorShown,
        updateProductInfo,
        validate,
    };
});
